"use strict";

/**
 * computes the number of copies given the order type & component's #up and quantity
 * @memberof ShinePrinting/Helpers
 * @param {PrintJob} printJob
 * @param {Product} product
 * @param {Component} component
 * @returns {Number}
 */
function computeCopies(component) {
  var up = component.up,
      quantity = component.quantity;
  var num_to_add = 0;

  if (quantity > 5) {
    num_to_add = component.num_to_add == null ? 4 : component.num_to_add;
  }

  if (up === 'n/a') {
    return parseInt(quantity, 10) + parseInt(num_to_add, 10);
  }

  return Math.ceil((parseInt(quantity, 10) + parseInt(num_to_add, 10)) / parseInt(up, 10));
}

module.exports = computeCopies;